import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageProvider';
import type { Language } from '../i18n/translations';
const OPTIONS: {
  code: Language;
  label: string;
}[] = [{
  code: 'es',
  label: 'ES'
}, {
  code: 'en',
  label: 'EN'
}];
type LanguageToggleProps = {
  tone?: 'dark' | 'light';
};
export function LanguageToggle({
  tone = 'dark'
}: LanguageToggleProps) {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const isDark = tone === 'dark';
  return <div className={`flex items-center gap-1.5 ${isDark ? 'text-paper/60' : 'text-muted'}`} role="group" aria-label={t.switchLabel} data-id="element-50" data-mp="21h45148aqgtx">
      <GlobeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-51" data-mp="2fa28lduw7f8k" />
      <div className={`flex overflow-hidden rounded-sm border ${isDark ? 'border-paper/25' : 'border-ink/25'}`} data-id="element-52" data-mp="2agh6paq6i143">
        {OPTIONS.map(option => {
        const active = option.code === language;
        return <button key={option.code} type="button" onClick={() => setLanguage(option.code)} aria-pressed={active} className={`px-2 py-0.5 text-[11px] font-bold tracking-[0.12em] transition-colors ${active ? 'bg-accent text-paper' : isDark ? 'hover:bg-paper/10' : 'hover:bg-ink/10'}`} data-id="element-53" data-mp="1hsbkskne262o">
              {option.label}
            </button>;
      })}
      </div>
    </div>;
}